export default __webpack_public_path__ + "static/media/linkedin.218bc902.svg";